import React, { useState, useRef } from "react";
import {
  Container,
  Card,
  CardContent,
  makeStyles,
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import QRCode from "qrcode";
import QrReader from "react-qr-reader";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../src/pages/Login";
import ScanQr from "./pages/ScanQr";
import GenerateQr from "./pages/GenerateQr";
import NoPage from "./pages/NoPage";
// import Analytics from "./pages/Analytics";
import useToken from "./Auth/UseToken";
import Home from "./pages/Home";
import UserTable from "./pages/UserTable.js";
import Welcome from "./pages/Welcome";
import Rfid from "./pages/Rfid.js";
import WelcomeGrid from "./pages/WelcomeGrid.js";
import Analytics from "./pages/analytics";
import RfidGenerate from "./pages/RfidGenerate.js";
import ManageExhibitors from "./pages/ManageExhibitors";
// import Register from "./pages/components/register.js";
import { Register } from "./pages/components/register.js";
import Merch from "./pages/components/merch.js";
import Dashboard from "./pages/components/dashboard.js";

function App() {
  const { token, setToken } = useToken();
  const [scanResultFile, setScanResultFile] = useState("");
  const [scanResultWebCam, setScanResultWebCam] = useState("");
  const classes = useStyles();
  const qrRef = useRef(null);

  const handleErrorFile = (error) => {
    console.log(error);
  };
  const handleScanFile = (result) => {
    if (result) {
      setScanResultFile(result);
    }
  };
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  };
  const handleErrorWebCam = (error) => {
    console.log(error);
  };
  const handleScanWebCam = (result) => {
    if (result) {
      setScanResultWebCam(result);
    }
  };

  if (!token) {
    return <Login setToken={setToken} />;
  } else {
    return (
      <BrowserRouter>
        <Routes>
          {/* {!token ? (<Route path="/"
              element={<Login />}>
  
            </Route>) : */}
          <Route path="/" element={<Home/>} />
          {/* } */}
          {/* <Route path="/" element={<Login/>} />
            <Route path="/scanqr" element={<ScanQr />} /> */}
          <Route path="/scan" element={<ScanQr isSelfCheckIn={false}/>} />
          <Route path="/selfCheckIn" element={<ScanQr isSelfCheckIn={true}/>} />
          <Route path="/generate" element={<GenerateQr />} />
          <Route path="/register" element={<Register />} />
          <Route path="/exhibitors" element={<ManageExhibitors />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/search" element={<UserTable />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/rfid" element={<Rfid />} />
          <Route path="/rfidgenerate" element={<RfidGenerate />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/welcomeGrid" element={<WelcomeGrid />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  conatiner: {
    marginTop: 10,
  },
  title: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#3f51b5",
    color: "#fff",
    padding: 20,
  },
  btn: {
    marginTop: 10,
    marginBottom: 20,
  },
}));
export default App;
